// Quiz Video System — Constants
// Dark Glassmorphism @ 60fps, IDV palette

import {IDV} from "../../../presets/idv";

// Timing (60fps)
export const QUESTION_FPS = 60;
export const WORD_GAP = 5;
export const BUTTON_ENTER_START = 40;
export const BUTTON_STAGGER = 8;
export const REVEAL_FRAME = 320;
export const POST_REVEAL_WAIT = 80;
export const EXIT_DURATION = 20;
export const EXIT_STAGGER = 3;
export const FRAMES_PER_QUESTION = 450; // ~7.5s at 60fps

// Colors (Glassmorphism + IDV)
export const BG_BLACK = "#000000";
export const TEXT_PRIMARY = "#f5f5f7";
export const TEXT_SECONDARY = "#86868b";
export const GLASS_BG = "rgba(255,255,255,0.08)";
export const GLASS_BORDER = "rgba(255,255,255,0.1)";

export const CORRECT_GREEN = IDV.secondary;
export const CORRECT_GREEN_BG = "rgba(0,223,130,0.3)";
export const CORRECT_GREEN_BORDER = "rgba(0,223,130,0.6)";
export const WRONG_OPACITY = 0.15;

export const CATEGORY_COLOR = IDV.primary;
export const TIMER_FILL = IDV.third;

// Confetti
export const CONFETTI_COLORS = [
  IDV.secondary,
  IDV.third,
  IDV.primary,
  "#ffffff",
  "#86868b",
];
export const CONFETTI_PARTICLES = 30;

// Helpers
export const CLAMP = {
  extrapolateLeft: "clamp" as const,
  extrapolateRight: "clamp" as const,
};

export const FONT_STACK =
  '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Inter", "Segoe UI", sans-serif';

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
